module.exports = __webpack_public_path__ + "img/churrasco.d0757a9e.svg";